import {scrollTop} from "../../main";

export default {
    namespaced: true,
    state: {
        mode: '',
        generator: '',
        urlSlug: '',
        hasSetToRecommended: false,
        cilinderFilter: 2,
        isLoading: true,
        locale: 'nl',
        magentoLoggedIn: false,
        defaultLocale: 'nl',
        liters: '0',
        pressure: '0',
        safetyPressure: 0,
        power: '0',
        cc: '1',
        selectedMotorGroup: null,
        selectedMotor: null,
        selectedCilinder: null,
        environment: -1,
        motorOptions: {
            mini_powerpack: false,
            workplace: false,
            and_pump: false,
            open_frame: false,
            closed_frame: false,
            industrial: false,
        },
        BTW: 21,
        cilinderOptions: {
            forceUnit: 1,
            circuit: 1,
            pressure: 0,
            oilFlow: 0,
            pistonDiameter: 0,
            rodDiameter: 0,
            stroke: 0,
            type: 0,
        },
        openAid: {
            type: '',
            tab: null,
            subtype: '',
        },
        //todo get attachments from database
        cilinderTypes: ['Zonder bevestiging', 'Gelenkoog', 'Standaard bevestiging', 'Frontflens', 'Gaffel', 'Topstangoog', 'Brede bevestiging'],
        cilinderTypesSingle: ['Oog', 'Zonder bevestiging'],
    },

    getters: {
        getMode(state) {
            return state.mode;
        },

        getGenerator(state) {
            return state.generator;
        },

        getUrlSlug(state) {
            return state.urlSlug;
        },

        getLocale(state) {
            return state.locale;
        },

        isMagento(state) {
            return state.mode === 'magento';
        },

        hasMotorOption(state) {
            return state.motorOptions.mini_powerpack ||
                state.motorOptions.workplace ||
                state.motorOptions.and_pump ||
                state.motorOptions.open_frame ||
                state.motorOptions.closed_frame ||
                state.motorOptions.industrial
        },

        getMotorOption(state) {
            for (let key in state.motorOptions) {
                if (state.motorOptions[key]) {
                    return key;
                }
            }

            return undefined;
        },
        getCilinderOptions(state) {
            return state.cilinderOptions;
        },
        getSelectedCilinder(state, getters, rootState, rootGetters) {
            return rootGetters['cilinders/byId'][state.selectedCilinder];
        },
        getModal(state) {
            return state.openAid;
        },
        getCilinderType(state) {
            return state.cilinderOptions.type;
        },
        getCilinderCircuit(state) {
            if (state.cilinderOptions.circuit === 2) {
                return 'single';
            } else if (state.cilinderOptions.circuit === 1) {
                return 'double';
            }
        },
        getCilinderTypes(state) {
            return state.cilinderTypes;
        },
        getCilinderTypeName(state, getters, rootState, rootGetters) {
            if (!rootGetters["cilinders/getAttachmentsById"][state.cilinderOptions.type]) return 'Alle bevestigingen';
            return rootGetters["cilinders/getAttachmentsById"][state.cilinderOptions.type].name;
            // return state.cilind[state.cilinderOptions.type - 1];
        }
    },

    actions: {
        updateLiters: ({commit}, value) => {
            commit('updateLiters', value);
        },
        updatePressure: ({commit, rootGetters}, value) => {
            commit('updatePressure', value);
            commit('updateSafetyPressure', value);
        },
        updatePower: ({commit}, value) => {
            commit('updatePower', value);
        },
        selectMotorGroup: ({commit}, value) => {
            commit('updateSelectedMotorGroup', value);
        },
        selectMotor: ({commit}, value) => {
            commit('updateSelectedMotor', value);
        },
        resetOptions: ({commit}) => {
            commit('resetMotorOptions');
        },
        resetCilinderType: ({commit}) => {
            commit('updateSelectedCilinder', null);
            commit('setCilinderType', 0);
        },
        selectCilinder: ({rootGetters, commit}, value) => {
            commit('updateSelectedCilinder', value);
            // let {rod_s, piston_al, stroke_k} = rootGetters["cilinders/byId"][value]
            // commit('setCilinderRodDiametersetCilinderStroke', rod_s);
            // commit('setCilinderPistonDiameter', piston_al);
            // commit('setCilinderRodDiameter', stroke_k);
        },
        resetSelection: ({commit}, value) => {
            commit('resetMotorSelection', value);
        },
        setMotorOption({commit, rootGetters}, slug) {
            commit('resetMotorOptions');
            commit('setMotorOption', slug);
        },
        setCilinderPistonDiameter({commit, state, dispatch}, value) {
            commit('updateSelectedCilinder', null);
            commit('setCilinderPistonDiameter', value);

            if (!state.hasSetToRecommended) commit('setToRecommended');
            // dispatch('findCilinderAfterInput');
        },
        setCilinderRodDiameter({commit, state, dispatch}, value) {
            commit('setCilinderRodDiameter', value);
            // dispatch('findCilinderAfterInput');
        },
        setCilinderStroke({commit, state, dispatch}, value) {
            commit('updateSelectedCilinder', null);
            commit('setCilinderStroke', value);

            if (!state.hasSetToRecommended) commit('setToRecommended');

            // dispatch('findCilinderAfterInput');
        },
        findCilinderAfterInput({commit, state, getters, rootState}) {
            let {stroke, rodDiameter, pistonDiameter, type} = state.cilinderOptions;

            let circuitName = getters.getCilinderCircuit;
            let found = rootState.cilinders.all.find((c) => {
                return (rodDiameter == c.rod_s &&
                    pistonDiameter == c.piston_al &&
                    stroke == c.stroke_k &&
                    c.type === circuitName &&
                    (c.attachment_id === type || type === 0)
                );
            })
            if (found) {
                commit('updateSelectedCilinder', found.id)
                commit('build/setCilinder', found.id, {root: true})
            }
        },
        setCilinderType({commit, dispatch, rootGetters}, value) {
            commit('setCilinderType', value);
            dispatch('findCilinderAfterInput');
        }
    },

    mutations: {
        setMode: (state, value) => {
            state.mode = value;
        },
        setGenerator: (state, value) => {
            state.generator = value;
        },
        setUrlSlug: (state, value) => {
            state.urlSlug = value;
        },
        setToRecommended: (state) => {
            state.hasSetToRecommended = true;
            state.cilinderFilter = 1;
        },
        setCilinderFilter: (state, value) => {
            state.cilinderFilter = value
        },
        finishedLoading: (state) => {
            state.isLoading = false;
        },
        setLocale: (state, value) => {
            state.locale = value;
        },
        setMagentoLoggedIn: (state, value) => {
            state.magentoLoggedIn = value;
        },
        updateLiters: (state, value) => {
            state.liters = value;
        },
        updatePressure: (state, value) => {
            state.pressure = value;
        },
        updatePower: (state, value) => {
            state.power = value;
        },
        updateSafetyPressure: (state, value) => {
            state.safetyPressure = value;
        },
        updateSelectedMotorGroup: (state, motorGroup) => {
            state.selectedMotorGroup = motorGroup;
        },
        updateSelectedMotor: (state, motor) => {
            state.selectedMotor = motor;
        },
        updateSelectedCilinder: (state, cilinder) => {
            state.selectedCilinder = cilinder;
        },
        setMotorOption: (state, value) => {
            let i = 0;
            for (let key in state.motorOptions) {
                if (key === value) break;
                i++;
            }
            state.environment = i;
            state.motorOptions[value] = true;
        },
        setCC: (state, value) => {
            state.cc = value;
        },
        resetMotorOptions: state => {
            state.environment = -1;
            state.motorOptions.mini_powerpack = false;
            state.motorOptions.workplace = false;
            state.motorOptions.and_pump = false;
            state.motorOptions.open_frame = false;
            state.motorOptions.diesel = false;
            state.motorOptions.closed_frame = false;
        },
        resetMotorSelection: (state) => {
            state.selectedMotor = null;

            scrollTop();
        },
        resetCilinderSelection: (state) => {
            state.selectedCilinder = null;
        },
        setCilinderType: (state, value) => {
            state.cilinderOptions.type = value;
        },
        setCilinderPressure: (state, value) => {
            state.cilinderOptions.pressure = value;
        },
        setCilinderOilFlow: (state, value) => {
            state.cilinderOptions.oilFlow = value;
        },
        setCilinderPistonDiameter: (state, value) => {
            state.cilinderOptions.pistonDiameter = value;
        },
        setCilinderRodDiameter: (state, value) => {
            state.cilinderOptions.rodDiameter = value;
        },
        setCilinderStroke: (state, value) => {
            state.cilinderOptions.stroke = value;
        },
        setCilinderCircuit: (state, value) => {
            state.cilinderOptions.circuit = value;
        },
        setCilinderForce: (state, value) => {
            state.cilinderOptions.forceUnit = value;
        },
        openAid: (state, data) => {
            state.openAid.type = data.type;
            state.openAid.tab = data.tab;
            state.openAid.subtype = data.subtype;
        },
    },
};
